import { z } from 'zod';

// Schema per le coordinate
const CoordinatesSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180)
});

// Schema per i contatti
const ContactSchema = z.object({
  type: z.enum(['email', 'instagram', 'x', 'linkedin', 'facebook', 'website']),
  value: z.string().min(1, 'Il valore del contatto è obbligatorio')
});

// Schema per gli items
const ItemSchema = z.object({
  name: z.string().min(1, 'Il nome dell\'articolo è obbligatorio').max(100, 'Il nome non può superare i 100 caratteri'),
  categoryId: z.string().min(1, 'La categoria è obbligatoria'),
  externalLink: z.string().optional(),
  categoryLabel: z.string().optional()
});

// Schema principale per la creazione di un GearPal
export const CreateGearPalFormSchema = z.object({
  name: z.string().min(2, 'Il nome è obbligatorio').max(100, 'Il nome non può superare i 100 caratteri'),
  zipcode: z.string().regex(/^[0-9]{5}$/, 'Il codice postale deve essere di 5 cifre'),
  city: z.string().min(1, 'La città è obbligatoria').max(100, 'La città non può superare i 100 caratteri'),
  region: z.string().min(1, 'La regione è obbligatoria').max(100, 'La regione non può superare i 100 caratteri'),
  country: z.string().min(1, 'Il paese è obbligatorio').max(100, 'Il paese non può superare i 100 caratteri'),
  coordinates: CoordinatesSchema,
  contacts: z.array(ContactSchema).min(1, 'Almeno un contatto è obbligatorio'),
  items: z.array(ItemSchema).min(1, 'Almeno un articolo è obbligatorio')
});

// Tipo TypeScript derivato dallo schema
export type CreateGearPalFormData = z.infer<typeof CreateGearPalFormSchema>; 